import { getCssColors } from "src/scss/theme";

/** Portal target so @-mention lists render above overflow:hidden/auto ancestors. */
export const MENTIONS_SUGGESTIONS_PORTAL_HOST =
  typeof document !== "undefined" ? document.body : undefined;

/** ~48px per suggestion row; show 8 emails, then scroll (keep in sync with mentionSuggestions.scss). */
export const MENTION_SUGGESTIONS_MAX_HEIGHT_PX = 48 * 8 + 8;

/** Control shell (border/background); padding lives on highlighter + input only. */
const controlShell = {
  minHeight: 60,
  padding: 0,
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  background: "#f9fbfd",
  outline: "none",
  fontSize: 14,
  lineHeight: 1.4,
  fontFamily: "inherit",
  resize: "vertical",
  boxSizing: "border-box",
};

/** Shared metrics for highlighter + textarea (must match exactly). */
const fieldMetrics = {
  padding: "10px 12px",
  margin: 0,
  border: "1px solid transparent",
  borderRadius: 8,
  fontSize: 14,
  lineHeight: 1.4,
  fontFamily: "inherit",
  fontWeight: 400,
  fontStyle: "normal",
  letterSpacing: "normal",
  wordSpacing: "normal",
  outline: "none",
  boxSizing: "border-box",
};

/** Inline highlight while typing — no extra padding (keeps lines aligned). */
export function getMentionHighlightStyle(colorOverrides = {}) {
  const { calipsoDark = "#176f80" } = {
    ...getCssColors(),
    ...colorOverrides,
  };

  // Same metrics as plain text — bold would shift the caret vs transparent textarea.
  return {
    color: calipsoDark,
    fontWeight: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
    verticalAlign: "baseline",
    textDecoration: "none",
    backgroundColor: "transparent",
  };
}

/** Inline styles for react-mentions (control + suggestions shell). */
export function getMentionsInputStyles(colorOverrides = {}) {
  const { calipsoPale = "#E6F6F5", calipsoDark = "#5AADA5", marengo = "#1f2d3a" } = {
    ...getCssColors(),
    ...colorOverrides,
  };

  return {
    control: { ...controlShell },
    "&multiLine": {
      control: { ...controlShell },
      // Highlighter: visible text + styled mentions (see mentionSuggestions.scss for __substring).
      highlighter: {
        ...fieldMetrics,
        color: marengo,
        backgroundColor: "transparent",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
      },
      // Input: transparent so mentions are not drawn twice (highlighter shows everything).
      input: {
        ...fieldMetrics,
        color: "transparent",
        caretColor: marengo,
        WebkitTextFillColor: "transparent",
        backgroundColor: "transparent",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
      },
    },
    suggestions: {
      marginTop: 6,
      zIndex: 10500,
      list: {
        backgroundColor: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(31, 45, 58, 0.1), 0 2px 6px rgba(31, 45, 58, 0.06)",
        fontSize: 13,
        maxHeight: MENTION_SUGGESTIONS_MAX_HEIGHT_PX,
        overflowY: "auto",
        padding: 4,
        minWidth: 260,
      },
      item: {
        padding: 0,
        borderBottom: "none",
        cursor: "pointer",
        color: marengo,
        "&focused": {
          backgroundColor: calipsoPale,
          color: calipsoDark,
        },
      },
    },
  };
}
